import { IAddAddressBody } from '@makyoapp/makyo-sdk/api/Organizations'
import { IAddress, IPaymentMethod } from '@makyoapp/makyo-sdk/models/Billing'
import { AddressAdapter, PaymentCardVariant, PaymentMethodAdapter } from '@makyoapp/makyo-common'

export function fromSdkAddressList(addresses: IAddress[]) {
  return addresses.map(fromSdkAddress)
}

export function fromSdkAddress(address: IAddress): AddressAdapter {
  return {
    addressLine1: address._Line1,
    addressLine2: address._Line2,
    city: address._City,
    country: address._Country,
    id: address._id,
    isDefault: address._Default,
    phone: address._PhoneNumber,
    state: address._State,
    title: address._Name,
    zip: address._PostalCode,
    created: address._CreatedAt,
    updated: address._UpdatedAt,
    accessed: address._AccessedAt,
  }
}

export function toSdkAddressBodyWithoutId(
  address: Omit<AddressAdapter, 'id' | 'created' | 'updated' | 'accessed'>
): IAddAddressBody {
  return {
    _City: address.city,
    _Country: address.country,
    _Default: address.isDefault,
    _Line1: address.addressLine1,
    _Line2: address.addressLine2 || '',
    _Name: address.title,
    _PhoneNumber: address.phone || '',
    _PostalCode: address.zip,
    _State: address.state,
  }
}

export function toSdkAddressBody(address: AddressAdapter): IAddress {
  return {
    _City: address.city,
    _Country: address.country,
    _Default: address.isDefault,
    _Line1: address.addressLine1,
    _Line2: address.addressLine2 || '',
    _Name: address.title,
    _PhoneNumber: address.phone || '',
    _PostalCode: address.zip,
    _State: address.state,
    _id: address.id,
    _UpdatedAt: address.updated,
    _CreatedAt: address.created,
    _AccessedAt: address.accessed,
  }
}

export function fromSdkPaymentList(payments: IPaymentMethod[]) {
  return payments.map(fromSdkPayment)
}

export function fromSdkPayment(payment: IPaymentMethod): PaymentMethodAdapter {
  let variant: PaymentCardVariant = PaymentCardVariant.Visa

  switch (payment._Brand) {
    case 'mastercard':
      variant = PaymentCardVariant.Master
      break
    case 'visa':
      variant = PaymentCardVariant.Visa
      break
    case 'discover':
    case 'discovery':
      variant = PaymentCardVariant.Discover
      break
    case 'amex':
    case 'americanexpress':
      variant = PaymentCardVariant.Amex
      break
  }

  return {
    addressId: payment._AddressID,
    expires: { month: payment._ExpMonth, year: payment._ExpYear },
    id: payment._id,
    isDefault: payment._Default,
    text: payment._CardNumber,
    nameOnCard: payment._Name,
    variant,
  }
}
